<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h1>404</h1>
        </div>
        <h2>{{'Page Not Found Title' | translate}}</h2>
        <p>{{'Page Not Found Message' | translate}}</p>
        <a [routerLink]="['/']">{{'Back To Homepage' | translate}}</a>
    </div>
</div>